<template>
  <div v-if="listings.length > 0 || card.ebayQuery" class="card-profile-shop">
    <align class="header" flex>
      <h4 class="secondary-font">
        Shop
      </h4>

      <icon-link
        v-if="listings.length > 0 && !isPublic"
        as="router-link"
        :to="`/shop?query=${encodedQuery}`"
      >
        View All Listings
      </icon-link>
    </align>

    <p class="affiliate-text">
      If you purchase an item after clicking any of these links, Card Ladder may be compensated at no additional cost to you.
    </p>

    <div v-if="card.ebayQuery" class="ebay-link">
      <card-ebay-link
        :query="card.ebayQuery"
        :is-public="isPublic"
      />
    </div>

    <div class="list">
      <shop-list-item
        v-for="item in listings"
        :key="item.listingId"
        :item="item"
        as="a"
        :href="item.url"
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  </div>
</template>

<script>
import Align from './Align';
import IconLink from './IconLink';
import ShopListItem from './ShopListItem';
import CardEbayLink from './CardEbayLink';

export default {
  components: {
    Align,
    IconLink,
    ShopListItem,
    CardEbayLink,
  },

  props: {
    card: Object,
    listings: Array,
    isPublic: Boolean,
  },

  computed: {
    encodedQuery() {
      return encodeURIComponent(this.card.ebayQuery);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-profile-shop {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}

.header {
  margin-bottom: $gp;

  h4 {
    margin-bottom: 0;
  }
}

.ebay-link {
  margin-bottom: $gp;
}

.list {
  margin: 0 (-$gp);
}
</style>
